var classes = {"step":"Step-module_step__lUJXM","circle":"Step-module_circle__Wm-1y","number":"Step-module_number__-Eihb","tick":"Step-module_tick__Wmblt","title":"Step-module_title__Z0cyT","active":"Step-module_active__-jSH7","done":"Step-module_done__9C-xr"};

export { classes as default };
